import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  response: null,
  user: "",
  error: "", // for error msg
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
};

const resetPwdSlice = createSlice({
  name: "resetpwd",
  initialState,
  reducers: {
    userResetPasswordSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
    },
    userResetPasswordError(state, action) {
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
  },
});
export const { userResetPasswordSuccess, userResetPasswordError } =
  resetPwdSlice.actions;
export default resetPwdSlice.reducer;
